class FormBuilder
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'form-builder--bound'
            @.$messageButton = @.$el.querySelector '.form-builder__content__message__container__button'
            @.$messageTextEl = @.$el.querySelector '.form-builder__content__message__container__text'

            @.action = @.$el.action ? false
            @.method = @.$el.method ? "POST"
            @.ajaxForm = @.$el.classList.contains 'form-builder--ajax-form'
            @.csrfToken = @.$el.querySelector('input[name="CRAFT_CSRF_TOKEN"]')?.value ? false
            @.error = @.$el.classList.contains 'form-builder--error'
            @.message = @.$el.classList.contains 'form-builder--message'
            @.processing = @.$el.classList.contains 'form-builder--processing'

            @.$el.classList.add 'form-builder--bound'
            @.InitEvents()
        return
    
    AjaxFormSubmit: ->
        self = @
        if @.action
            formData = new FormData @.$el
            ajaxFormRequest = new XMLHttpRequest()
            ajaxFormRequest.onreadystatechange = ->
                if ajaxFormRequest.readyState == 4
                    if ajaxFormRequest.status == 200
                        ajaxFormResponse = JSON.parse ajaxFormRequest.responseText
                        console.log "RESPONSE", ajaxFormResponse
                        self.SetProcessingState false
                        if ajaxFormResponse.success
                            self.SetMessage ajaxFormResponse.message
                        else
                            self.SetMessage ajaxFormResponse.message, true
                    else
                        self.SetProcessingState false
                        self.SetMessage "Beim Absenden des Formulars gab es leider ein Problem.", true
            ajaxFormRequest.open @.method, @.action
            ajaxFormRequest.send(formData)
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'submit', (e) ->
            e.preventDefault()
            self.SetProcessingState true
            if self.Validate()
                if self.ajaxForm && self.action
                    self.AjaxFormSubmit()
                else
                    @.submit()
                    self.SetProcessingState false
            else
                self.SetProcessingState false
            return
        if @.$messageButton
            @.$messageButton.addEventListener 'click', (e) ->
                e.preventDefault()
                if !self.error
                    self.ResetForm()
                self.SetMessage false
                return
        return
    
    SetMessage: (message, error) ->
        if message
            @.$messageTextEl.innerHTML = message
            @.message = true
            @.$el.classList.add 'form-builder--message'
            if error
                @.error = true
                @.$el.classList.add 'form-builder--error'
        else
            @.$messageTextEl.innerHTML = ""
            @.error = false
            @.message = false
            @.$el.classList.remove 'form-builder--error'
            @.$el.classList.remove 'form-builder--message'
        return
    
    SetProcessingState: (state) ->
        if state
            @.$el.classList.add 'form-builder--processing'
        else
            @.$el.classList.remove 'form-builder--processing'
        @.processing = state
        return
    
    ResetForm: ->
        @.$el.querySelectorAll '.checkbox'
            .forEach (checkboxEl) ->
                checkboxEl.dispatchEvent new CustomEvent 'checkbox-reset', { bubbles: false }
                return
        @.$el.querySelectorAll '.input'
            .forEach (inputEl) ->
                inputEl.dispatchEvent new CustomEvent 'input-reset', { bubbles: false }
                return
        @.$el.querySelectorAll '.select'
            .forEach (selectEl) ->
                selectEl.dispatchEvent new CustomEvent 'select-reset', { bubbles: false }
                return
        return
    
    Validate: ->
        valid = true
        # validate inputs
        @.$el.querySelectorAll '.input'
            .forEach (inputEl) ->
                inputElInputField = inputEl.querySelector '.input__input-field'
                if inputElInputField?.required
                    if inputElInputField.value == ""
                        inputEl.dispatchEvent new CustomEvent 'input-set-error', {
                            bubbles: false
                            detail: {
                                showError: true
                            }
                        }
                        valid = false
                return
        # validate checkboxes
        @.$el.querySelectorAll '.checkbox'
            .forEach (checkboxEl) ->
                if checkboxEl.classList.contains 'checkbox--required'
                    checkboxInputEl = checkboxEl.querySelector 'input[type="checkbox"]'
                    if !checkboxInputEl?.checked
                        checkboxEl.dispatchEvent new CustomEvent 'checkbox-set-error', {
                            bubbles: false
                            detail: {
                                showError: true
                            }
                        }
                        valid = false
                return
        # validate selects
        @.$el.querySelectorAll '.select'
            .forEach (selectEl) ->
                if selectEl.classList.contains 'select--required'
                    selectSelectEl = selectEl.querySelector 'select'
                    if selectSelectEl
                        if selectSelectEl.value == "" || selectSelectEl.value == "---placeholder---"
                            selectEl.dispatchEvent new CustomEvent 'select-set-error', {
                                bubbles: false
                                detail: {
                                    showError: true
                                }
                            }
                            valid = false
                return
        return valid
    
BindFormBuilders = ->
    document.querySelectorAll '.form-builder:not(.form-builder--bound)'
        .forEach (el) ->
            new FormBuilder el
            return
    return

window.addEventListener 'bind-components', BindFormBuilders